import { render, staticRenderFns } from "./youtubeOverview.vue?vue&type=template&id=46198c3c&scoped=true&"
import script from "./youtubeOverview.vue?vue&type=script&lang=js&"
export * from "./youtubeOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46198c3c",
  null
  
)

export default component.exports